import { render } from "./Widget.vue?vue&type=template&id=629d0f7e&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=629d0f7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629d0f7e"]])

export default __exports__